import React from "react";

import "./sponsored-tag.m.css";

const SponsoredTag = () => {
  return <div styleName="wrapper">ಪ್ರಾಯೋಜಿತ ಲೇಖನ</div>;
};

export default SponsoredTag;
